import { Component, OnInit } from '@angular/core';
import { PaysheetService } from 'src/app/services/paysheet.service';
import { CustomerService } from 'src/app/services/customer.service';
import { UnityService } from 'src/app/services/unity.service';
import { Paysheet } from 'src/app/models/paysheet';
import { AuthService } from 'src/app/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UnitType } from 'src/app/models/unit-type';
import { Customer } from 'src/app/models/customer';
import { UnitTypeService } from 'src/app/services/unit-type.service';
import { CustomerAddress } from 'src/app/models/customer-address';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-paysheet',
  templateUrl: './paysheet.component.html',
  styleUrls: ['./paysheet.component.css']
})
export class PaysheetComponent implements OnInit {

  loading:boolean = false;
  paysheets:Paysheet[] = [];
  paysheet:Paysheet = new Paysheet();
  expand:boolean = false;

  customers:Customer[] = [];
  customer:Customer = new Customer();
  customerAddress:CustomerAddress = new CustomerAddress();
  customerAddresses:CustomerAddress[] = [];
  unitTypes:UnitType[] = [];
  unitType:UnitType;

  public actEditPaysheet:boolean = true;
  public actAddPaysheet:boolean = true;
  public actDeletePaysheet:boolean = true;

  constructor(private payServ:PaysheetService, private custServ:CustomerService, private unitServ:UnitTypeService, private authService:AuthService, private modalService:NgbModal, private utl:UtilitiesService, private toastr: ToastrManager) { }

  ngOnInit() {
    this.loading = true;
    this.payServ.getPaysheets().then(paysheets => {
      this.paysheets = paysheets;
      this.loading = false;
    });

    this.custServ.getCustomers().then(customers => {
      this.customers = customers.filter(cust => cust.type != 'Compañia');
      this.customer = this.customers[0];
      this.customerAddresses = this.customers[0].directions;
      this.customerAddress = this.customerAddresses[0];
    });
    this.unitServ.getTypes().then(types => {
      this.unitTypes = types;
      this.unitType = this.unitTypes[0];
    });

    this.actEditPaysheet = this.authService.can("update-paysheet");
    this.actAddPaysheet = this.authService.can("destroy-paysheet");
    this.actDeletePaysheet = this.authService.can("store-paysheet");
  }

  select(modal?, paysheet?:Paysheet) {
    if(paysheet) {
      this.paysheet = paysheet;

      this.customer = this.customers.find(cust => cust.id == this.paysheet.customer_id);
      this.customerAddresses = this.customer.directions;
      this.customerAddress = this.customerAddresses.find(add => add.id == this.paysheet.customer_address_id);
      this.unitType = this.unitTypes.find(type => type.id == this.paysheet.unit_type_id);
    } else {
      this.paysheet = new Paysheet();

      this.customer = this.customers[0];
      this.customerAddresses = this.customers[0].directions;
      this.customerAddress = this.customerAddresses[0];
      this.unitType = this.unitTypes[0];
    }

    if(modal) {
      this.modalService.open(modal, { size: 'lg' });
    }
  }

  changeCustomer() {
    this.customerAddresses = this.customer.directions;
    this.customerAddress = this.customerAddresses[0];
  }

  changeIds() {
    this.paysheet.customer_address_id = this.customerAddress.id;
    this.paysheet.customer_id = this.customer.id;
    this.paysheet.unit_type_id = this.unitType.id;
  }

  storePaysheet (event) {
    event.preventDefault();

    this.changeIds();

    this.loading = true;

    this.payServ.postPaysheet(this.paysheet)
      .then(res => {
        this.toastr.successToastr('Creado Correctamente');
        this.paysheets.push(res);
        this.loading = false;
      })
      .catch(e => {
        this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
        this.loading = false;
      });
  }

  updatePaysheet(event) {
    event.preventDefault();

    this.changeIds();

    this.loading = true;

    this.payServ.putPaysheet(this.paysheet)
      .then(res => {
        this.toastr.successToastr('Actualizado Correctamente');
        this.loading = false;
      })
      .catch(e => {
        this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
        this.loading = false;
      });
  }

  deleteProduct() {
    this.loading = true;
    this.payServ.deletePaysheet(this.paysheet)
      .then(res => {
        this.toastr.successToastr('Eliminado Correctamente');
        this.paysheets = this.paysheets.filter(pay => pay != this.paysheet);
        this.loading = false;
      });
  }

}
